// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    background-color: #3c4f58;
    padding: 0.05rem 1rem ;
}

.navbar-links {
    list-style: none;
    display: flex;
    gap: 1rem;
    justify-content: right;
}

.navbar-links a {
    text-decoration: none;
    color: #fff;
    font-size: 1rem;
    font-family: Iowan Old Style-Roman;
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,kCAAkC;AACtC","sourcesContent":[".navbar {\r\n    background-color: #3c4f58;\r\n    padding: 0.05rem 1rem ;\r\n}\r\n\r\n.navbar-links {\r\n    list-style: none;\r\n    display: flex;\r\n    gap: 1rem;\r\n    justify-content: right;\r\n}\r\n\r\n.navbar-links a {\r\n    text-decoration: none;\r\n    color: #fff;\r\n    font-size: 1rem;\r\n    font-family: Iowan Old Style-Roman;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
